module.exports = __webpack_public_path__ + "img/floor2_top2.6b3e183c.png";